import { isArray } from './tool'
import { throttle } from './utils'
import { auto_refresh_30min, auto_refresh_7d } from '@/pages/firebase'
import dayjs from 'dayjs'
import { storage } from './storage'
import { apiInit } from '@/api/init'
import { globalVariable } from '@/utils/exportVariable'
import { region } from '@/utils/utils'

const AUTO_REFRESH_7D_TS = '@@auto_refresh_7d_ts'

/**
 * 自动刷新
 * 针对30min没有任何操作的用户进行强制刷新
 */

const isProd = process.env.VUE_APP_ENV === 'prod'

class AutoRefresh {
  constructor() {
    this.startTs = +new Date()
    // 测试环境1min不操作会刷新，方便测试
    this.duration = isProd ? 30 * 60 * 1000 : 10 * 60 * 1000
    this.eventMaps = ['click', 'scroll']
    this.bindEvent()
    this.timeid = null
    this.refresh = false
  }

  addEvent(en) {
    if (en) {
      this.eventMaps = isArray(en)
        ? [...this.eventMaps].concat([...en])
        : [...this.eventMaps].concat(en)
    }
    return this
  }

  bindEvent() {
    if (process.client) {
      this.eventMaps.forEach((eventName) => {
        eventName === 'scroll'
          ? window.addEventListener(
              eventName,
              throttle(this.eventHandler.bind(this), 500),
              true
            )
          : window.addEventListener(
              eventName,
              this.eventHandler.bind(this),
              true
            )
      })
    }
  }

  eventHandler() {
    this.startTs = +new Date()
    if (this.refresh) {
      window.location.reload()
    }
  }

  monitor() {
    if (!process.client) {
      return
    }
    this.timeid = setInterval(() => {
      const currentTs = +new Date()
      const diffTs = currentTs - this.startTs
      // 30min无任何操作，自动刷新
      if (diffTs >= this.duration) {
        clearInterval(this.timeid)
        auto_refresh_30min()
        this.refresh = true
        this.createMask()
      }
      // 发版时间
      // 如果当前用户的版本时间和当前时间之差大于7天，自动刷新
      const currentBuildTime = window.__app_buildTime
      if (
        currentBuildTime &&
        currentBuildTime !== 'undefined' &&
        currentBuildTime !== 'null'
      ) {
        const currentBuildTs = dayjs(currentBuildTime).unix()
        const currentTime = dayjs().unix()
        const diff = currentTime - currentBuildTs
        const day7 = 7 * 24 * 60 * 60

        const cacheTs = storage.get(AUTO_REFRESH_7D_TS)
        if (!cacheTs) {
          storage.set(AUTO_REFRESH_7D_TS, currentTime)
          return
        }
        const cacheDiff = currentTime - cacheTs

        if (diff >= day7 && cacheDiff >= day7) {
          clearInterval(this.timeid)
          storage.set(AUTO_REFRESH_7D_TS, currentTime)
          auto_refresh_7d()
          window.location.reload()
        }
      }
      this.updateAPISign()
    }, 1000)

    this.monitorBrowserVisibility()
  }

  // 超过一定的时间主动更新签名信息
  updateAPISign() {
    const store = globalVariable?.store || {}
    const preApiSign = store?.state?.common?.apiSign || {}
    const { responseTime = 0 } = preApiSign
    // 测试环境30min会更新，方便测试
    const hourTs = isProd ? 23.95 * 60 * 60 * 1000 : 30 * 60 * 1000
    const currentTs = +new Date()
    const diffTs = currentTs - responseTime
    if (diffTs > hourTs) {
      apiInit(region()).then((apiSign) => {
        if (apiSign && Object.keys(apiSign).length) {
          store.commit &&
            typeof store.commit === 'function' &&
            store.commit('common/setApiSign', apiSign)
        }
      })
    }
  }

  // 浏览器从后台切到前台
  // 如果在后台时间过长的需要更新签名
  monitorBrowserVisibility() {
    if (!process.client) {
      return
    }
    const __self = this
    // 设置隐藏属性和改变可见属性的事件的名称
    var hidden, visibilityChange
    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      hidden = 'hidden'
      visibilityChange = 'visibilitychange'
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden'
      visibilityChange = 'msvisibilitychange'
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden'
      visibilityChange = 'webkitvisibilitychange'
    }
    // 如果浏览器不支持 addEventListener 或 Page Visibility API 给出警告
    if (
      typeof document.addEventListener === 'undefined' ||
      typeof document[hidden] === 'undefined'
    ) {
      /* eslint-disable */
      console.log(
        'This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.'
      )
    } else {
      // 处理页面可见属性的改变
      document.addEventListener(
        visibilityChange,
        () => {
          if (!document[hidden]) {
            /* eslint-disable */
            // console.log('浏览器被置于前台了～', +new Date())
            __self.updateAPISign()
          } else {
            /* eslint-disable */
            // console.log('浏览器被置于后台了～', +new Date())
          }
        },
        false
      )
    }
  }

  // 蒙层
  createMask() {
    if (!process.client) {
      return
    }
    const div = document.createElement('div')
    div.style.position = 'fixed'
    div.style.left = '0'
    div.style.top = '0'
    div.style.width = '100%'
    div.style.height = '100%'
    div.style.background = 'transparent'
    div.style.zIndex = '9999'
    document.body.style.overflow = 'hidden'
    document.body.appendChild(div)
  }
}

const autoRefresh = new AutoRefresh()
autoRefresh.monitor()
